import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-toggle-switch-input',
  standalone: true,
  templateUrl: './toggle-switch-input.component.html',
  styleUrls: ['./toggle-switch-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleSwitchInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ToggleSwitchInputComponent implements ControlValueAccessor {
  @Input() controlId: string | null = null;
  @Input({ required: true }) ariaLabel!: string;
  @Output() toggled = new EventEmitter<boolean>();

  public generatedRandomId = `toggle-switch-${Math.random().toString(36).slice(2)}`;

  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};
  public disabled: boolean = false;

  public isChecked: boolean = false;

  public writeValue(value: boolean): void {
    this.isChecked = !!value;
  }

  public registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public toggle(): void {
    if (this.disabled) {
      return;
    }
    this.isChecked = !this.isChecked;
    this.onChange(this.isChecked);
    this.onTouched();
    this.toggled.emit(this.isChecked);
  }
}
